// When building, Gatsby renders components on the server, where navigator isn't defined
const getNavigator = () => typeof navigator !== 'undefined' && navigator;

export default getNavigator;
